import React, {useEffect, useState} from 'react'
import Star from "../icons/Star";

export default function CardOngoing({item, onClick}) {

    return (
        <>
            <div className="cart-ongoing">
                <div className="img">
                    <img src={`https://www.mnfansubs.net/resource/${item.image?.name}_s.${item.image?.ext}`} alt=""/>
                </div>
                <div className={"overlay"}>
                    <div className="about">
                            <div className={"title"}>
                                <span>
                                    {item.name}
                                </span>
                            </div>
                        {
                            item.description &&
                                <div className={"desc"}>
                                    <span>
                                        {item.description}
                                    </span>
                                </div>
                        }
                        <div className={"sub"}>
                            {
                                item.year &&
                                <div className={"flex"}>
                                <span>
                                    Гарч эхэлсэн:
                                </span>
                                    <span>
                                    {item.year}
                                </span>
                                </div>
                            }
                            {
                                item.totalNumber &&
                                <div className={"flex"}>
                                <span>
                                    Ангийн тоо:
                                </span>
                                    <span>
                                    {item.totalNumber}
                                </span>
                                </div>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <div className={"card-common-mobile"}
                 onMouseDown={onClick}

            >
                <div className={"img"}>
                    <img src={`https://www.mnfansubs.net/resource/${item.image?.name}.${item?.image?.ext}`}/>
                </div>
                <div className={"about"}>
                    {
                        item.score &&
                        <div className={"rating"}>
                            <Star stroke={"#FF6600"}/>
                            <span>{item.score}</span>
                        </div>

                    }
                    <div className={"title"}>
                        <a>{item.name}</a>
                    </div>
                    <div className={"flex gap-1"}>
                        <div>
                            <span>{item.year}</span>
                        </div>
                        {
                            item.totalNumber &&
                            <div>
                                <span>• {item.totalNumber} анги</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>


    )
}
